import { Component, OnInit, Input } from "@angular/core";
import { DialogueSettingService } from "@root/router/message/dialogue-setting.service";
import { NzModalService } from "ng-zorro-antd/modal";

import _ from "lodash";
import { AddQuickMessageGroupComponent } from "../add-quick-message-group/add-quick-message-group.component";
import { TranslateService } from "@root/shared/service/translate.service";
import { RateTemplateService } from "@root/router/rate/rate-template/rate-template.service";

@Component({
  selector: "host-manage-group",
  templateUrl: "./manage-group.component.html",
  styleUrls: ["./manage-group.component.scss"],
})
export class ManageGroupComponent implements OnInit {
  @Input() isSubAccount = false;
  @Input() template: 'message' | 'rate' = 'message';
  groupList = [];

  constructor(
    private dialogueSettingService: DialogueSettingService,
    private rateService: RateTemplateService,
    private modalService: NzModalService,
    private translateService: TranslateService
  ) {}

  ngOnInit() {
    this.fetchGroupList();
  }

  fetchGroupList() {
    if (this.template === 'message') {
      this.fetchMessageGroupList();
    } else {
      this.fetchRateGroupList();
    }
  }

  private fetchMessageGroupList () {
    this.dialogueSettingService.getQuickMessageGroupList().subscribe((res) => {
      if (res.error_code === 0) {
        this.groupList = this.format(_.get(res, "data.list"));
      }
    });
  }

  private fetchRateGroupList () {
    this.rateService.fetchGroupList().subscribe(res => {
      this.groupList = this.format(_.get(res, 'data.list') || []);
    });
  }

  private removeMessageGroup (id) {
    this.dialogueSettingService.removeQuickMessageGroup({ id: id }).subscribe((res) => {
      if (res.error_code === 0) {
        this.fetchGroupList();
      }
    });
  }

  private removeRateGroup (id) {
    this.rateService.removeGroup({ id }).subscribe(res => {
      if (res.error_code === 0) {
        this.fetchGroupList();
      }
    });
  }

  format(list) {
    _.forEach(list, (group) => {
      _.assign(group, {
        new: false,
      });
    });
    return list;
  }

  edit(group) {
    const titleList = _.map(this.groupList, "name");
    console.log(titleList);
    this.modalService.create({
      // 编辑分组
      nzTitle: this.translateService.syncGet("dialogue_setting.modify_group"),
      nzContent: AddQuickMessageGroupComponent,
      nzWidth: 480,
      nzFooter: null,
      nzComponentParams: {
        isSubAccount: this.isSubAccount,
        group: group,
        titleList: titleList,
        template: this.template
      },
      nzOnOk: () => {
        this.fetchGroupList();
      },
    });
  }

  delete(id) {
    if (this.template === 'message') {
      this.removeMessageGroup(id);
    } else {
      this.removeRateGroup(id);
    }
  }

  addGroup() {
    this.modalService.create({
      // 新建分组
      nzTitle: this.translateService.syncGet("dialogue_setting.create_group"),
      nzContent: AddQuickMessageGroupComponent,
      nzWidth: 480,
      nzFooter: null,
      nzComponentParams: {
        isSubAccount: this.isSubAccount,
        template: this.template
      },
      nzOnOk: () => {
        this.fetchGroupList();
      },
    });
  }
}
